import ajaxService from './ajaxService';

export default {
  // 取得會員資料
  getCustomerData(body, headers) {
    return ajaxService.post('/mbc/post/api/v1/customerdataquery', body, headers);
  },
  // 取得會籍資料
  getMemberType(body, headers) {
    return ajaxService.post('/mbc/post/api/v1/member-type-query', body, headers);
  },
  // 新增會員個人通知
  postMemberNotice(body, headers) {
    return ajaxService.post('/mbc/post/api/v1/member/notice', body, headers);
  },
  // 驗證帳號存在
  getAccountVerifier(param) {
    const queryString = new URLSearchParams(param).toString();
    return ajaxService.post(`/mbc/get/api/v1/account-verifier?${queryString}`);
  },
  // 查詢客戶
  getCustomer(body) {
    return ajaxService.post('/mbc/post/api/v1/customer', body);
  },
  postCustomerdataadd(body, headers) {
    return ajaxService.post('/mbc/post/api/v1/customerdataadd', body, headers);
  },
  getMemberAccount(params) {
    const queryString = new URLSearchParams(params).toString();
    return ajaxService.post(`/mbc/get/api/v1/member-account?${queryString}`);
  },
  postCustomerdatabind(body) {
    return ajaxService.post('/mbc/post/api/v1/customerdatabind', body);
  },
  postMemberProspectiveCustomerRelease(body) {
    return ajaxService.post('/mbc/post/api/v1/member/prospective-customer/release', body);
  },
};
